import { AxiosResponseHeaders, RawAxiosResponseHeaders } from 'axios';

export const downloadBlobFile = (blob: Blob, fileName?: string) => {
    // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    //     window.navigator.msSaveOrOpenBlob(blob, fileName || 'file');
    //     return;
    // }

    const url = window.URL.createObjectURL(blob);
    downloadFileByUrl(url, fileName);
    window.URL.revokeObjectURL(url);
};

export const downloadFileByUrl = (url: string, fileName?: string) => {
    const a = document.createElement('a');

    a.setAttribute('display', 'none');
    a.href = url;
    if (fileName) {
        a.download = fileName;
    }
    if (typeof a.download === 'undefined') {
        a.setAttribute('target', '_blank');
    }

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
};

const extractFileNameFromHeaders = (headers: RawAxiosResponseHeaders | AxiosResponseHeaders) => {
    const defaultName = 'data';
    const contentDisposition = (headers as AxiosResponseHeaders).get('content-disposition');

    if (!contentDisposition) {
        return 'data';
    }

    const segments = contentDisposition.toString().split('; ');

    let filename = segments.find((s) => s.startsWith('filename*='))?.replace("filename*=UTF-8''", '');
    if (!filename) {
        filename = segments.find((s) => s.startsWith('filename='))?.replace('filename=', '');
    }

    return filename ? decodeURIComponent(filename) : defaultName;
};

export const getFilenameWithoutExtension = (filename: string) => filename?.split('.').slice(0, -1).join('.');

export const getFileExtension = (filename: string) => filename?.split('.').at(-1);

const blobToBase64 = async (blob: Blob) =>
    new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = () => {
            const base64File = reader.result as string;
            const header = ';base64,';
            const fileData = base64File.substring(base64File.indexOf(header) + header.length);
            resolve(fileData);
        };
        reader.onerror = reject;
    });

export default {
    downloadBlobFile,
    downloadFileByUrl,
    getFilenameWithoutExtension,
    getFileExtension,
    extractFileNameFromHeaders,
    blobToBase64
};
